import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=2bb9a3eb&scoped=true&"
import script from "./dialog.vue?vue&type=script&lang=js&"
export * from "./dialog.vue?vue&type=script&lang=js&"
import style0 from "./dialog.vue?vue&type=style&index=0&id=2bb9a3eb&lang=less&scoped=true&"
import style1 from "./dialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb9a3eb",
  null
  
)

export default component.exports